import { c as _c } from "react/compiler-runtime";
import type * as React from "react";

// Linear label dot: an 8px circle that keys a row to a categorical colour
// drawn elsewhere (map markers, chart series). `color` must reference a
// design-system token, so raw hex can't reach it.
export type SwatchProps = Omit<React.HTMLAttributes<HTMLSpanElement>, "children" | "className" | "color" | "style"> & {
  color: `hsl(var(--${string}))`;
};

/** Use when a dot keys a row to a colour shown elsewhere, such as a map marker. */
export function Swatch(t0) {
  const $ = _c(8);
  let color;
  let props;
  if ($[0] !== t0) {
    ({
      color,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = color;
    $[2] = props;
  } else {
    color = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== color) {
    t1 = {
      backgroundColor: color
    };
    $[3] = color;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <span aria-hidden="true" className="inline-block size-2 shrink-0 rounded-full" style={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}